import React from 'react';
import './styles.css';

const LoadingFull = () => (
  <div className="loading-wrapper">
    <div className="loading-full" />
  </div>
);

export default LoadingFull;



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingFull.js